// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CortexLink-module__font-s-10___AQisY {
  font-size: 10px !important;
}

.CortexLink-module__font-s-12___D9T81 {
  font-size: 12px !important;
}

.CortexLink-module__font-s-13___dMdEl {
  font-size: 13px !important;
}

.CortexLink-module__font-s-14___zrhbS {
  font-size: 14px !important;
}

.CortexLink-module__font-s-15___N9IYm {
  font-size: 15px !important;
}

.CortexLink-module__font-s-16___ohgXF {
  font-size: 16px !important;
}

.CortexLink-module__font-s-18___cw0vp {
  font-size: 18px !important;
}

.CortexLink-module__font-s-20___hm9Vh {
  font-size: 20px !important;
}

.CortexLink-module__font-s-22___ihJcr {
  font-size: 22px !important;
}

.CortexLink-module__font-s-28___LYBSG {
  font-size: 28px !important;
}

.CortexLink-module__font-w-400___HimD3 {
  font-weight: 400 !important;
}

.CortexLink-module__font-w-500___DVuCZ {
  font-weight: 500 !important;
}

.CortexLink-module__font-w-600___IkAvw {
  font-weight: 600 !important;
}

.CortexLink-module__font-w-700___pqugH {
  font-weight: 700 !important;
}

.CortexLink-module__p-5___NX6iB {
  padding: 5px !important;
}

.CortexLink-module__p-12___YHP78 {
  padding: 12px !important;
}

.CortexLink-module__p-16___ItLSk {
  padding: 16px !important;
}

.CortexLink-module__p-30___bZOkX {
  padding: 30px !important;
}

.CortexLink-module__p-b-0___tRrn7 {
  padding-bottom: 0 !important;
}

.CortexLink-module__p-b-5___yHx60 {
  padding-bottom: 5px !important;
}

.CortexLink-module__p-b-10___WlyPZ {
  padding-bottom: 10px !important;
}

.CortexLink-module__p-b-12___JpDo2 {
  padding-bottom: 12px !important;
}

.CortexLink-module__p-b-16___PAjTU {
  padding-bottom: 16px !important;
}

.CortexLink-module__p-b-18___Hhglz {
  padding-bottom: 18px !important;
}

.CortexLink-module__p-b-20___UB1dl {
  padding-bottom: 20px !important;
}

.CortexLink-module__p-b-25___i6C8t {
  padding-bottom: 25px !important;
}

.CortexLink-module__p-b-30___MSggJ {
  padding-bottom: 30px !important;
}

.CortexLink-module__p-b-50___i6jAS {
  padding-bottom: 50px !important;
}

.CortexLink-module__p-t-0___xHIZB {
  padding-top: 0 !important;
}

.CortexLink-module__p-t-12___LjCty {
  padding-top: 12px !important;
}

.CortexLink-module__p-t-16___qg2GT {
  padding-top: 16px !important;
}

.CortexLink-module__p-t-18___JfbI7 {
  padding-top: 18px !important;
}

.CortexLink-module__p-t-20___B5VU2 {
  padding-top: 20px !important;
}

.CortexLink-module__p-t-30___r4WEk {
  padding-top: 30px !important;
}

.CortexLink-module__p-t-40___yxC0W {
  padding-top: 40px !important;
}

.CortexLink-module__p-t-50___qcvnu {
  padding-top: 50px !important;
}

.CortexLink-module__p-l-20____ZduU {
  padding-left: 20px !important;
}

.CortexLink-module__p-l-30___V65DQ {
  padding-left: 30px !important;
}

.CortexLink-module__p-l-40___fppT5 {
  padding-left: 40px !important;
}

.CortexLink-module__p-r-16___fa0Xs {
  padding-right: 16px !important;
}

.CortexLink-module__p-r-20___S5NzA {
  padding-right: 20px !important;
}

.CortexLink-module__p-r-30___XZOJw {
  padding-right: 30px !important;
}

.CortexLink-module__p-r-50___d9y36 {
  padding-right: 50px !important;
}

.CortexLink-module__p-r-60___vGgjz {
  padding-right: 60px !important;
}

.CortexLink-module__m-b-1___IjX_N {
  margin-bottom: 1px !important;
}

.CortexLink-module__m-b-2___inFcL {
  margin-bottom: 2px !important;
}

.CortexLink-module__m-b-6___uBu0U {
  margin-bottom: 6px !important;
}

.CortexLink-module__m-b-8___NCiQ1 {
  margin-bottom: 8px !important;
}

.CortexLink-module__m-b-10___NMXyG {
  margin-bottom: 10px !important;
}

.CortexLink-module__m-b-14___oMQiU {
  margin-bottom: 14px !important;
}

.CortexLink-module__m-b-16___CL1zt {
  margin-bottom: 16px !important;
}

.CortexLink-module__m-b-20___TCTgm {
  margin-bottom: 20px !important;
}

.CortexLink-module__m-b-22___HjZgx {
  margin-bottom: 22px !important;
}

.CortexLink-module__m-b-24___Sh089 {
  margin-bottom: 24px !important;
}

.CortexLink-module__m-b-30___BMNJQ {
  margin-bottom: 30px !important;
}

.CortexLink-module__m-b-32___t6H1i {
  margin-bottom: 32px !important;
}

.CortexLink-module__m-b-40___hChqr {
  margin-bottom: 40px !important;
}

.CortexLink-module__m-t-2___Mg9oB {
  margin-top: 2px !important;
}

.CortexLink-module__m-t-3___eTreT {
  margin-top: 3px !important;
}

.CortexLink-module__m-t-4___qqN44 {
  margin-top: 4px !important;
}

.CortexLink-module__m-t-5___G_SU7 {
  margin-top: 5px !important;
}

.CortexLink-module__m-t-8___vej9N {
  margin-top: 8px !important;
}

.CortexLink-module__m-t-10___xL5wN {
  margin-top: 10px !important;
}

.CortexLink-module__m-t-15___jxpcd {
  margin-top: 15px !important;
}

.CortexLink-module__m-t-16___UeOOl {
  margin-top: 16px !important;
}

.CortexLink-module__m-t-20___ByJHv {
  margin-top: 20px !important;
}

.CortexLink-module__m-t-22___fLk4R {
  margin-top: 22px !important;
}

.CortexLink-module__m-t-30___HzMiI {
  margin-top: 30px !important;
}

.CortexLink-module__m-t-32___xBP5j {
  margin-top: 32px !important;
}

.CortexLink-module__m-l-auto___S6sv9 {
  margin-left: auto !important;
}

.CortexLink-module__m-l-4___yctDf {
  margin-left: 4px !important;
}

.CortexLink-module__m-l-5___BC6Xp {
  margin-left: 5px !important;
}

.CortexLink-module__m-l-6___w8e20 {
  margin-left: 6px !important;
}

.CortexLink-module__m-l-8___ap9Dy {
  margin-left: 8px !important;
}

.CortexLink-module__m-l-10___nqOl2 {
  margin-left: 10px !important;
}

.CortexLink-module__m-l-16___TMuKy {
  margin-left: 16px !important;
}

.CortexLink-module__m-l-20___TOd4M {
  margin-left: 20px !important;
}

.CortexLink-module__m-l-24___hlflc {
  margin-left: 24px !important;
}

.CortexLink-module__m-l-30___hrmhy {
  margin-left: 30px !important;
}

.CortexLink-module__m-l-35___xQCpu {
  margin-left: 35px !important;
}

.CortexLink-module__m-l-40___ssrKW {
  margin-left: 40px !important;
}

.CortexLink-module__m-r-8___HeWSC {
  margin-right: 8px !important;
}

.CortexLink-module__m-r-10___oUcDw {
  margin-right: 10px !important;
}

.CortexLink-module__m-r-16___a9hoY {
  margin-right: 16px !important;
}

.CortexLink-module__m-r-20___nJheR {
  margin-right: 20px !important;
}

.CortexLink-module__m-r-24___XTz8V {
  margin-right: 24px !important;
}

.CortexLink-module__m-r-30___OBUze {
  margin-right: 30px !important;
}

.CortexLink-module__m-r-40___c6llT {
  margin-right: 40px !important;
}

.CortexLink-module__border-r-3___QaO5g {
  border-radius: 3px !important;
}

.CortexLink-module__border-r-4___Xu1Sf {
  border-radius: 4px !important;
}

.CortexLink-module__border-r-6___N7Dm0 {
  border-radius: 6px !important;
}

.CortexLink-module__border-r-10___UJ6u0 {
  border-radius: 10px !important;
}

.CortexLink-module__border-r-12___zr4eK {
  border-radius: 12px !important;
}

.CortexLink-module__border-r-16___ecWJ2 {
  border-radius: 16px !important;
}

.CortexLink-module__border-r-50___FejRN {
  border-radius: 50% !important;
}

.CortexLink-module__primary-border___egZAV {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CortexLink-module__primary-border-b___nbyzS {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CortexLink-module__primary-border-t___XrAbL {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CortexLink-module__primary-border-l___f01Cs {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CortexLink-module__primary-border-r___pYKlb {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CortexLink-module__secondary-border___z27II {
  border: 1px solid #637768;
}

.CortexLink-module__secondary-border-b___s6oBm {
  border-bottom: 1px solid #637768;
}

.CortexLink-module__secondary-border-t___P0DZx {
  border-top: 1px solid #637768;
}

.CortexLink-module__secondary-border-l___oQosz {
  border-left: 1px solid #637768;
}

.CortexLink-module__secondary-border-r___XHzlE {
  border-right: 1px solid #637768;
}

.CortexLink-module__gap-0___yuZdE {
  gap: 0 !important;
}

.CortexLink-module__gap-2___V3h0w {
  gap: 2px !important;
}

.CortexLink-module__gap-4___CxVcE {
  gap: 4px !important;
}

.CortexLink-module__gap-5___a9nBI {
  gap: 5px !important;
}

.CortexLink-module__gap-6___h2x2W {
  gap: 6px !important;
}

.CortexLink-module__gap-8___sfiuB {
  gap: 8px !important;
}

.CortexLink-module__gap-10___uXebu {
  gap: 10px !important;
}

.CortexLink-module__gap-12___S0sVK {
  gap: 12px !important;
}

.CortexLink-module__gap-14___HLzLG {
  gap: 14px !important;
}

.CortexLink-module__gap-16___NS5bM {
  gap: 16px !important;
}

.CortexLink-module__gap-18___KetSJ {
  gap: 18px !important;
}

.CortexLink-module__gap-20___jlBdd {
  gap: 20px !important;
}

.CortexLink-module__gap-24___EJdCL {
  gap: 24px !important;
}

.CortexLink-module__gap-26___jGO2j {
  gap: 26px !important;
}

.CortexLink-module__gap-30___RdNA9 {
  gap: 30px !important;
}

.CortexLink-module__gap-32___UAF_7 {
  gap: 32px !important;
}

.CortexLink-module__gap-40___RIpqa {
  gap: 40px !important;
}

.CortexLink-module__gap-50___zg3XA {
  gap: 50px !important;
}

.CortexLink-module__flex-1___3sGGU {
  flex: 1;
}

.CortexLink-module__flex-none___PpRmX {
  flex: none !important;
}

.CortexLink-module__flex-column___i9ooc {
  display: flex;
  flex-direction: column !important;
}

.CortexLink-module__flex-row___EBG8D {
  display: flex;
  flex-direction: row !important;
}

.CortexLink-module__vertically-centered___fqQli {
  display: flex;
  align-items: center !important;
}

.CortexLink-module__horizontally-centered___D9M4m {
  display: flex;
  justify-content: center !important;
}

.CortexLink-module__horizontally-end___O83Zr {
  display: flex;
  justify-content: end !important;
}

.CortexLink-module__vertically-start___TpsKg {
  display: flex;
  align-items: start !important;
}

.CortexLink-module__space-between___IdJwD {
  display: flex;
  justify-content: space-between !important;
}

.CortexLink-module__flex-wrap___fWq7W {
  flex-wrap: wrap !important;
}

.CortexLink-module__height-100___S9NMv {
  height: 100%;
}

.CortexLink-module__width-50___NluJL {
  width: 50% !important;
}

.CortexLink-module__width-100___YluwR {
  width: 100%;
}

.CortexLink-module__cursor-pointer___kGO1Z {
  cursor: pointer;
}

.CortexLink-module__cursor-not-allowed___f9D7i {
  cursor: not-allowed !important;
}

.CortexLink-module__absolute-centered___EZbrN {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CortexLink-module__absolute___UMfqj {
  position: absolute;
}

.CortexLink-module__relative_____M6V {
  position: relative;
}

.CortexLink-module__fixed___pzZs8 {
  position: fixed;
}

.CortexLink-module__visible___mTHCT {
  opacity: 1;
}

.CortexLink-module__invisible___af4sL {
  opacity: 0;
}

.CortexLink-module__col-90___aBEOH {
  width: 90% !important;
}

.CortexLink-module__col-auto___Onyv0 {
  width: auto !important;
}

.CortexLink-module__medical-tabs___UZCxw {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CortexLink-module__medical-table-new___i2pxt {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CortexLink-module__medical-table-new___i2pxt:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CortexLink-module__medical-table-new___i2pxt::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CortexLink-module__medical-table-new___i2pxt::-webkit-scrollbar-track {
  display: none;
}
.CortexLink-module__medical-table-new___i2pxt.CortexLink-module__no-pagination___DgRXM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CortexLink-module__medical-table-new___i2pxt.CortexLink-module__no-pagination___DgRXM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CortexLink-module__medical-table-new___i2pxt.CortexLink-module__no-pagination___DgRXM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CortexLink-module__medical-table-new___i2pxt.CortexLink-module__no-pagination___DgRXM::-webkit-scrollbar-track {
  display: none;
}

.CortexLink-module__medical-table-empty___TQjHB {
  padding: 14px 40px !important;
}

.CortexLink-module__icon-btn___jOfk_ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CortexLink-module__search-icon___cOKtu {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CortexLink-module__disable-select___EkLyK {
  user-select: none;
}

.CortexLink-module__break-word___Qc5LL {
  word-break: break-word;
}

.CortexLink-module__popup-clear-btn___r7ahL {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CortexLink-module__scroll-m-b-20___deY1Y {
  scroll-margin-bottom: 20px;
}

.CortexLink-module__link___Dfw1j {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  width: 100%;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  text-decoration: none;
  color: #18181b;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;
  text-align: left;
}

.CortexLink-module__link___Dfw1j:hover {
  border-color: #a1a1aa;
}

.CortexLink-module__link___Dfw1j:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.CortexLink-module__badge___URDnZ {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #18181b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.CortexLink-module__badgeText___wCyq7 {
  font-size: 10px;
  font-weight: 700;
  color: #fafafa;
  font-family: "IBM Plex Mono", monospace;
}

.CortexLink-module__meta___rTMGV {
  flex: 1;
}

.CortexLink-module__title___g6dJ3 {
  font-size: 11px;
  font-weight: 600;
}

.CortexLink-module__arrow___dWyMt {
  font-size: 13px;
  color: #a1a1aa;
}

.CortexLink-module__line___rcfFU {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.CortexLink-module__line___rcfFU:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.CortexLink-module__line___rcfFU {
  outline: none;
}
.CortexLink-module__line___rcfFU:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.CortexLink-module__line___rcfFU:disabled, .CortexLink-module__line___rcfFU[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/CortexLink/CortexLink.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mEAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF;;AA3pBA;EACE,0BAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AA8pBF;;AA3pBA;EACE,OAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;AA8pBF;;AA3pBA;EEXE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AF0qBF;AExqBE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AF0qBJ;AArrBA;EEpBE,aAAA;AF4sBF;AE1sBE;EACE,0BAAA;EACA,mBALuB;AFitB3B;AE5qBE;EAEE,cAAA;EACA,eAAA;AF6qBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  width: 100%;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  text-decoration: none;\n  color: #18181b;\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background-color 0.15s;\n  text-align: left;\n}\n\n.link:hover {\n  border-color: #a1a1aa;\n}\n\n.link:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.badge {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  background: #18181b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.badgeText {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fafafa;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.meta {\n  flex: 1;\n}\n\n.title {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.arrow {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.line {\n  @include line-button;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CortexLink-module__font-s-10___AQisY`,
	"fontS12": `CortexLink-module__font-s-12___D9T81`,
	"fontS13": `CortexLink-module__font-s-13___dMdEl`,
	"fontS14": `CortexLink-module__font-s-14___zrhbS`,
	"fontS15": `CortexLink-module__font-s-15___N9IYm`,
	"fontS16": `CortexLink-module__font-s-16___ohgXF`,
	"fontS18": `CortexLink-module__font-s-18___cw0vp`,
	"fontS20": `CortexLink-module__font-s-20___hm9Vh`,
	"fontS22": `CortexLink-module__font-s-22___ihJcr`,
	"fontS28": `CortexLink-module__font-s-28___LYBSG`,
	"fontW400": `CortexLink-module__font-w-400___HimD3`,
	"fontW500": `CortexLink-module__font-w-500___DVuCZ`,
	"fontW600": `CortexLink-module__font-w-600___IkAvw`,
	"fontW700": `CortexLink-module__font-w-700___pqugH`,
	"p5": `CortexLink-module__p-5___NX6iB`,
	"p12": `CortexLink-module__p-12___YHP78`,
	"p16": `CortexLink-module__p-16___ItLSk`,
	"p30": `CortexLink-module__p-30___bZOkX`,
	"pB0": `CortexLink-module__p-b-0___tRrn7`,
	"pB5": `CortexLink-module__p-b-5___yHx60`,
	"pB10": `CortexLink-module__p-b-10___WlyPZ`,
	"pB12": `CortexLink-module__p-b-12___JpDo2`,
	"pB16": `CortexLink-module__p-b-16___PAjTU`,
	"pB18": `CortexLink-module__p-b-18___Hhglz`,
	"pB20": `CortexLink-module__p-b-20___UB1dl`,
	"pB25": `CortexLink-module__p-b-25___i6C8t`,
	"pB30": `CortexLink-module__p-b-30___MSggJ`,
	"pB50": `CortexLink-module__p-b-50___i6jAS`,
	"pT0": `CortexLink-module__p-t-0___xHIZB`,
	"pT12": `CortexLink-module__p-t-12___LjCty`,
	"pT16": `CortexLink-module__p-t-16___qg2GT`,
	"pT18": `CortexLink-module__p-t-18___JfbI7`,
	"pT20": `CortexLink-module__p-t-20___B5VU2`,
	"pT30": `CortexLink-module__p-t-30___r4WEk`,
	"pT40": `CortexLink-module__p-t-40___yxC0W`,
	"pT50": `CortexLink-module__p-t-50___qcvnu`,
	"pL20": `CortexLink-module__p-l-20____ZduU`,
	"pL30": `CortexLink-module__p-l-30___V65DQ`,
	"pL40": `CortexLink-module__p-l-40___fppT5`,
	"pR16": `CortexLink-module__p-r-16___fa0Xs`,
	"pR20": `CortexLink-module__p-r-20___S5NzA`,
	"pR30": `CortexLink-module__p-r-30___XZOJw`,
	"pR50": `CortexLink-module__p-r-50___d9y36`,
	"pR60": `CortexLink-module__p-r-60___vGgjz`,
	"mB1": `CortexLink-module__m-b-1___IjX_N`,
	"mB2": `CortexLink-module__m-b-2___inFcL`,
	"mB6": `CortexLink-module__m-b-6___uBu0U`,
	"mB8": `CortexLink-module__m-b-8___NCiQ1`,
	"mB10": `CortexLink-module__m-b-10___NMXyG`,
	"mB14": `CortexLink-module__m-b-14___oMQiU`,
	"mB16": `CortexLink-module__m-b-16___CL1zt`,
	"mB20": `CortexLink-module__m-b-20___TCTgm`,
	"mB22": `CortexLink-module__m-b-22___HjZgx`,
	"mB24": `CortexLink-module__m-b-24___Sh089`,
	"mB30": `CortexLink-module__m-b-30___BMNJQ`,
	"mB32": `CortexLink-module__m-b-32___t6H1i`,
	"mB40": `CortexLink-module__m-b-40___hChqr`,
	"mT2": `CortexLink-module__m-t-2___Mg9oB`,
	"mT3": `CortexLink-module__m-t-3___eTreT`,
	"mT4": `CortexLink-module__m-t-4___qqN44`,
	"mT5": `CortexLink-module__m-t-5___G_SU7`,
	"mT8": `CortexLink-module__m-t-8___vej9N`,
	"mT10": `CortexLink-module__m-t-10___xL5wN`,
	"mT15": `CortexLink-module__m-t-15___jxpcd`,
	"mT16": `CortexLink-module__m-t-16___UeOOl`,
	"mT20": `CortexLink-module__m-t-20___ByJHv`,
	"mT22": `CortexLink-module__m-t-22___fLk4R`,
	"mT30": `CortexLink-module__m-t-30___HzMiI`,
	"mT32": `CortexLink-module__m-t-32___xBP5j`,
	"mLAuto": `CortexLink-module__m-l-auto___S6sv9`,
	"mL4": `CortexLink-module__m-l-4___yctDf`,
	"mL5": `CortexLink-module__m-l-5___BC6Xp`,
	"mL6": `CortexLink-module__m-l-6___w8e20`,
	"mL8": `CortexLink-module__m-l-8___ap9Dy`,
	"mL10": `CortexLink-module__m-l-10___nqOl2`,
	"mL16": `CortexLink-module__m-l-16___TMuKy`,
	"mL20": `CortexLink-module__m-l-20___TOd4M`,
	"mL24": `CortexLink-module__m-l-24___hlflc`,
	"mL30": `CortexLink-module__m-l-30___hrmhy`,
	"mL35": `CortexLink-module__m-l-35___xQCpu`,
	"mL40": `CortexLink-module__m-l-40___ssrKW`,
	"mR8": `CortexLink-module__m-r-8___HeWSC`,
	"mR10": `CortexLink-module__m-r-10___oUcDw`,
	"mR16": `CortexLink-module__m-r-16___a9hoY`,
	"mR20": `CortexLink-module__m-r-20___nJheR`,
	"mR24": `CortexLink-module__m-r-24___XTz8V`,
	"mR30": `CortexLink-module__m-r-30___OBUze`,
	"mR40": `CortexLink-module__m-r-40___c6llT`,
	"borderR3": `CortexLink-module__border-r-3___QaO5g`,
	"borderR4": `CortexLink-module__border-r-4___Xu1Sf`,
	"borderR6": `CortexLink-module__border-r-6___N7Dm0`,
	"borderR10": `CortexLink-module__border-r-10___UJ6u0`,
	"borderR12": `CortexLink-module__border-r-12___zr4eK`,
	"borderR16": `CortexLink-module__border-r-16___ecWJ2`,
	"borderR50": `CortexLink-module__border-r-50___FejRN`,
	"primaryBorder": `CortexLink-module__primary-border___egZAV`,
	"primaryBorderB": `CortexLink-module__primary-border-b___nbyzS`,
	"primaryBorderT": `CortexLink-module__primary-border-t___XrAbL`,
	"primaryBorderL": `CortexLink-module__primary-border-l___f01Cs`,
	"primaryBorderR": `CortexLink-module__primary-border-r___pYKlb`,
	"secondaryBorder": `CortexLink-module__secondary-border___z27II`,
	"secondaryBorderB": `CortexLink-module__secondary-border-b___s6oBm`,
	"secondaryBorderT": `CortexLink-module__secondary-border-t___P0DZx`,
	"secondaryBorderL": `CortexLink-module__secondary-border-l___oQosz`,
	"secondaryBorderR": `CortexLink-module__secondary-border-r___XHzlE`,
	"gap0": `CortexLink-module__gap-0___yuZdE`,
	"gap2": `CortexLink-module__gap-2___V3h0w`,
	"gap4": `CortexLink-module__gap-4___CxVcE`,
	"gap5": `CortexLink-module__gap-5___a9nBI`,
	"gap6": `CortexLink-module__gap-6___h2x2W`,
	"gap8": `CortexLink-module__gap-8___sfiuB`,
	"gap10": `CortexLink-module__gap-10___uXebu`,
	"gap12": `CortexLink-module__gap-12___S0sVK`,
	"gap14": `CortexLink-module__gap-14___HLzLG`,
	"gap16": `CortexLink-module__gap-16___NS5bM`,
	"gap18": `CortexLink-module__gap-18___KetSJ`,
	"gap20": `CortexLink-module__gap-20___jlBdd`,
	"gap24": `CortexLink-module__gap-24___EJdCL`,
	"gap26": `CortexLink-module__gap-26___jGO2j`,
	"gap30": `CortexLink-module__gap-30___RdNA9`,
	"gap32": `CortexLink-module__gap-32___UAF_7`,
	"gap40": `CortexLink-module__gap-40___RIpqa`,
	"gap50": `CortexLink-module__gap-50___zg3XA`,
	"flex1": `CortexLink-module__flex-1___3sGGU`,
	"flexNone": `CortexLink-module__flex-none___PpRmX`,
	"flexColumn": `CortexLink-module__flex-column___i9ooc`,
	"flexRow": `CortexLink-module__flex-row___EBG8D`,
	"verticallyCentered": `CortexLink-module__vertically-centered___fqQli`,
	"horizontallyCentered": `CortexLink-module__horizontally-centered___D9M4m`,
	"horizontallyEnd": `CortexLink-module__horizontally-end___O83Zr`,
	"verticallyStart": `CortexLink-module__vertically-start___TpsKg`,
	"spaceBetween": `CortexLink-module__space-between___IdJwD`,
	"flexWrap": `CortexLink-module__flex-wrap___fWq7W`,
	"height100": `CortexLink-module__height-100___S9NMv`,
	"width50": `CortexLink-module__width-50___NluJL`,
	"width100": `CortexLink-module__width-100___YluwR`,
	"cursorPointer": `CortexLink-module__cursor-pointer___kGO1Z`,
	"cursorNotAllowed": `CortexLink-module__cursor-not-allowed___f9D7i`,
	"absoluteCentered": `CortexLink-module__absolute-centered___EZbrN`,
	"absolute": `CortexLink-module__absolute___UMfqj`,
	"relative": `CortexLink-module__relative_____M6V`,
	"fixed": `CortexLink-module__fixed___pzZs8`,
	"visible": `CortexLink-module__visible___mTHCT`,
	"invisible": `CortexLink-module__invisible___af4sL`,
	"col90": `CortexLink-module__col-90___aBEOH`,
	"colAuto": `CortexLink-module__col-auto___Onyv0`,
	"medicalTabs": `CortexLink-module__medical-tabs___UZCxw`,
	"medicalTableNew": `CortexLink-module__medical-table-new___i2pxt`,
	"noPagination": `CortexLink-module__no-pagination___DgRXM`,
	"medicalTableEmpty": `CortexLink-module__medical-table-empty___TQjHB`,
	"iconBtn": `CortexLink-module__icon-btn___jOfk_`,
	"searchIcon": `CortexLink-module__search-icon___cOKtu`,
	"disableSelect": `CortexLink-module__disable-select___EkLyK`,
	"breakWord": `CortexLink-module__break-word___Qc5LL`,
	"popupClearBtn": `CortexLink-module__popup-clear-btn___r7ahL`,
	"scrollMB20": `CortexLink-module__scroll-m-b-20___deY1Y`,
	"link": `CortexLink-module__link___Dfw1j`,
	"badge": `CortexLink-module__badge___URDnZ`,
	"badgeText": `CortexLink-module__badgeText___wCyq7`,
	"meta": `CortexLink-module__meta___rTMGV`,
	"title": `CortexLink-module__title___g6dJ3`,
	"arrow": `CortexLink-module__arrow___dWyMt`,
	"line": `CortexLink-module__line___rcfFU`
};
module.exports = ___CSS_LOADER_EXPORT___;
